import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { CardAccountInfo } from '@entities/current-user/ui/card-account-info/card-account-info';
import { ProfilePhotoEdit } from '@features/current-user/edit-profile/ui/profile-photo-edit/profile-photo-edit';
import { useCurrentOrganizationPreviewSharedQuery } from '@entities/organization/libs/hooks/use-current-organization-preview-shared-query/use-current-organization-preview-shared-query';
import { ListOwnProducts } from '@pages/main-admin-page/ui/list-own-products/list-own-products';
import { PersonalCatalog } from '@pages/main-admin-page/ui/personal-catalog/personal-catalog';
import { userName } from '@shared/lib/utils/user-name/user-name';
import { ListPreviewApprovalEmployeeRequests } from '@widgets/list-preview-approval-employee-requests/ui/list-preview-approval-employee-requests';
import React from 'react';

export const MainViewEmployee: React.FC = () => {
    const user = useCurrentUserSelector();
    const [, getCurrentOrganizationPreviewResult] = useCurrentOrganizationPreviewSharedQuery(user?.company?.id || 0);

    return (
        <>
            <CardAccountInfo
                avatarUrl={user?.photoUrl || ''}
                name={userName({ ...user }).full}
                role={user?.role.roleName || ''}
                department={user?.department?.name || ''}
                showEditButton={true}>
                <ProfilePhotoEdit isEditMode={false} />
            </CardAccountInfo>
            <PersonalCatalog />
            <ListOwnProducts />
            {getCurrentOrganizationPreviewResult.data?.manager && <ListPreviewApprovalEmployeeRequests />}
        </>
    );
};
